import { createSlice } from '@reduxjs/toolkit';
import {getDefaultDate} from '../js/function'

// const urlParams = new URLSearchParams(window.location.search);
const currentUrl = window.location.href;
let currentBookingId='select-vehicle'
// const currentorderId = urlParams.get("orderId");
if(currentUrl.includes('booking')&&currentUrl.includes('success')){
  currentBookingId='success'
}
if(currentUrl.includes('booking')&&currentUrl.includes('failed')){
  currentBookingId='failed'
}
const date = getDefaultDate()
const initialState = {
  searchData: {
    pickup: '',
    dropoff: 'same_as_pickup',
    startDate: date[0],
    endDate: date[1],
    startTime: '10:00',
    endTime: '10:00',
    driverage: '25+',
    damageLiability: '',
    vehicleDetails: [],
    vehiclePrice:'',
    included_kilometres:'',
  },
  selectedExtraOptions: {},
  bookingStep:1,
  // orderID:currentorderId?currentorderId:'',
  bookingId:currentBookingId,
  // itemPrice:{},
  initData:{},
};

export const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    // setItemPrice: (state, action) => {
    //   const { key, value } = action.payload;
    //   state.itemPrice[key] = value; 
    // },
    setInitData: (state, action) => {
      state.initData = action.payload;
    },
    // setOrderID:(state, action) => {
    //   state.orderID = action.payload;
    // },
    setBookingStep:(state, action) => {
      state.bookingStep = action.payload;
    },
    updateSearchData: (state, action) => {
      state.searchData[action.payload.key] = action.payload.value;
    },
    updateSelectedExtraOptions: (state, action) => {
      const key = action.payload.key;
      state.selectedExtraOptions[key] = (state.selectedExtraOptions[key] || 0) + 1;
    },
    deleteSelectedExtraOption: (state, action) => {
      const key = action.payload.key;
      if (state.selectedExtraOptions[key] > 1) {
        state.selectedExtraOptions[key] -= 1;
      } else {
        delete state.selectedExtraOptions[key];
      }
    },
    getSearchData: (state, action) => {
      state.value = action.payload;
    },
    setBookingId:(state, action) => {
      state.bookingId = action.payload;
    },
  },
});

export const { setInitData,setBookingId,getSearchData, setBookingStep,updateSearchData, updateSelectedExtraOptions, deleteSelectedExtraOption } = dataSlice.actions;

export default dataSlice.reducer;